import create from 'zustand'

const useStore = create((set, get) => ({
  playerScore: 0,
  countdown: 0,
  highScore: 0,
  actions: {
    collectPuck: (v) => set((state) => ({ playerScore: state.playerScore + v, highScore: Math.max(state.highScore, state.playerScore + v) })),
    resetScore: () => set((state) => ({ playerScore: 0 })),
    setCountdown: (v) => set((state) => ({ countdown: v }))
  }
}))

export default useStore;